<template>
  <div v-loading="initLoading">
  <div style="width: 500px;background-color: #fafafa;padding: 20px" >
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ManagerView' }" >导购业务员对接</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-col :span="24">
        <div style="font-size: 25px;margin-top: 15px;">
          <p>导购业务员对接</p>
        </div>
      </el-col>
    </el-row>
    <div style="width: 100%; font-family: 宋体; font-size: 25px;font-weight: bold">
      <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" style=" margin-top: 30px" >
        <el-form-item label="供应商" prop="selectedSupplierIds">
          <el-select  v-model="ruleForm2.selectedSupplierIds" value-key="id" filterable multiple placeholder="请选择"  @change="supplierid()" style="width: 400px">
            <el-option
              v-for="(item) in user"
              :key="item.id"
              :label="item.name"
              :value='item'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域" prop="selectRegionals">
          <el-select popper-class="el-select" v-model.number="ruleForm2.selectedRegionals" multiple style="width: 400px" value-key="id" @change="selectRegionalss" placeholder="可筛选，不筛选则导出全部" :disabled="ruleForm2.selectedSupplierIds != '' && ruleForm2.selectedSupplierIds.length === 1 ?false:true">
            <select-all-option v-model="ruleForm2.selectedRegionals" group-value="regionals" @change="selectRegionalss" :data="selectRegionals"/>
            <el-option-group
              v-for="group in selectRegionals"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.regionals"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="省份" prop="selectProvinces">
          <el-select popper-class="el-select" v-model.number="ruleForm2.selectedProvinces"  style="width: 400px" value-key="id"   multiple placeholder="可筛选，不筛选则导出全部" :disabled="ruleForm2.selectedRegionals != '' ?false:true">
            <select-all-option v-model="ruleForm2.selectedProvinces" group-value="children" :data="selectProvinces"/>
            <el-option-group
              v-for="group in selectProvinces"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.children"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <el-row style="margin-left: 100px;text-align: center">
        <el-col :span="12">
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading" @click="importManager">导出填写模板</el-button>
        </el-col>
        <el-col :span="12">
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading2" @click="uploadManager" :disabled="dashboardSales">上传对接信息</el-button>
          <input type="file" ref="uploadManager" v-show="false" accept=".xls,.xlsx" @change="managerExcel"/>
        </el-col>
      </el-row>
    </div>
  </div>
  </div>
</template>

<script>
import { allUser,getUserSupplier } from '@/api/ReportDetailPage'
import { importManager,putManagerExcel } from '@/api/ReportDetailPagePurchase'
import selectAllOption from "@/components/selectAllOption";
export default {
  components: {selectAllOption},
  data () {
    return {
      ruleForm2: { selectedSupplierIds: '', selectedRegionals: '', selectedProvinces: ''
      },
      // 判断供应商是否选择
      rules2: {
        selectedSupplierIds: [
          { required: true, message: '请至少选择一个供应商', trigger: 'change' }
        ]
      },
      user: [],
      value: '',
      selectRegionals: [],
      selectProvinces: [],
      token: '',
      loading: false,
      loading2: false,
      fileList:[],
      supplierId: '',
      dashboardSales:false,
      initLoading:true
    }
  },
  created () {
    // 进入测页面以后 查询出下拉框的所有值
    this.allUser()
    this.$store.commit('addTips', ['每次修改信息时都请重新下载模板后再填写，以避免模板数据与当前数据不符而产生差错', '单次上传允许修改的数据量：30000条'])
    this.dashboardSales = localStorage.getItem('dashboardSales') == 2 ? true : false
  },
  methods: {
    uploadManager(){
      if (this.ruleForm2.selectedSupplierIds.length <1){
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
        return
      }
      this.supplierId = this.ruleForm2.selectedSupplierIds[0].id
      this.$refs.uploadManager.click()
    },
    managerExcel(){
      this.loading2 = true
      let inputDOM = this.$refs.uploadManager
      let file = inputDOM.files[0]
      let formData = new FormData();
      formData.append("file",file)
      putManagerExcel(this.token,this.supplierId,formData).then(r => {
        let {data} = r
        if (data.code == 200)
          this.$notify.success({
            title: '成功',
            message: data.msg,
            position: 'bottom-right'
          })
        if (data.code == 1)
          this.$notify.error({
            title: '错误',
            message: data.msg,
            position: 'bottom-right'
          })
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '数据中心修改失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading2 = false
        this.$refs.uploadManager.value = ''
      })
    },
    supplierid () {
      // 根据选择的供应商赋值给品牌和区域
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds != '') {
        if (this.ruleForm2.selectedSupplierIds.length > 1) {
          this.ruleForm2.selectedSupplierIds.splice(1, 1)
          this.$notify({
            title: '警告',
            message: '只能选择一个供应商',
            type: 'warning',
            position: 'bottom-right'
          })
        }
        this.selectRegionals = this.ruleForm2.selectedSupplierIds
      } else {
        this.ruleForm2.selectedRegionals = []
        this.ruleForm2.selectedProvinces = []
      }
    },
    selectRegionalss () {
      // 根据选择的区域赋值给不同的省份
      this.selectProvinces = this.ruleForm2.selectedRegionals
    },
    allUser () {
      this.token = localStorage.getItem('token')
      getUserSupplier(this.token).then(res => {
        if (res.data.suppliers != null) {
          this.user = res.data.suppliers
          if (this.user.length == 1){
            this.ruleForm2.selectedSupplierIds = this.user;
            this.supplierid();
          }
        }
        this.initLoading = false
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      })
    },
    importManager () {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds != '') {
        this.token = localStorage.getItem('token')
        // eslint-disable-next-line eqeqeq
        if (this.ruleForm2.selectedBrands == '') {
          this.ruleForm2.selectedBrands = this.ruleForm2.selectedParentBrands
        }
        this.loading = true
        importManager(this.token, this.ruleForm2,localStorage.getItem('managerId')).then(res => {
          if (res !== null) {
            this.$notify({
              type: 'success',
              message: '导出成功',
              title: '成功',
              position: 'bottom-right'
            })
            this.handleDownload(res)
            this.loading = false
          }
        }).catch(error => {
          let status = error.response.status;
          if (status == 500) {
            this.$notify({
              title: '错误',
              message: '导出错误，请及时联系管理员',
              type: 'error',
              position: 'bottom-right'
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    handleDownload (res) {
      console.log(res)
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>

<style scoped>
.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
